export default __webpack_public_path__ + "static/media/flag-fra.ab8a0607.svg";